// Q. APP NAME 변경해도 되는지
export const APP_NAME = 'HKMCOneApp';

export const RETRY_COUNT = 3;

export const UNIT = {
  KM: 'km',
  KML: 'km/l',
  KW: 'kW',
  KWH: 'kWh',
  KM_KWH: 'km/kWh',
  PERCENT: '%',
};

export const ERROR = {
  DASH: '-',
  ZERO: 0,
};

export enum FALLBACK {
  ERROR,
  LOADING,
}

export const DEFAULT_CACHE_TIME = {
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
};
export const NO_CACHE_TIME = {
  staleTime: 0,
  gcTime: 0,
};
